import React, { useState, useEffect } from 'react';
import { MonitoringConfig } from './types';

interface Props {
  onConfigChange: (config: MonitoringConfig) => void;
}

const MonitoringConfigComponent: React.FC<Props> = ({ onConfigChange }) => {
  const [companyDescription, setCompanyDescription] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [agencies, setAgencies] = useState<string>('');
  const [keywords, setKeywords] = useState<string>('');

  useEffect(() => {
    if (companyDescription.trim() && email.trim()) {
      const config: MonitoringConfig = {
        companyDescription: companyDescription.trim(),
        email: email.trim(),
        ...(agencies.trim() && { agencies: agencies.split(',').map(a => a.trim()).filter(a => a) }),
        ...(keywords.trim() && { keywords: keywords.split(',').map(k => k.trim()).filter(k => k) }),
      };
      onConfigChange(config);
    }
  }, [companyDescription, email, agencies, keywords]);


  return (
    <div className="monitoring-config">
      <h2>Legal Watchdog Configuration</h2>
      <p className="subtitle">Configure your government agency monitoring preferences</p>

      <div className="config-section">
        <label htmlFor="companyDescription">Company Description & Monitoring Requirements: *</label>
        <textarea
          id="companyDescription"
          value={companyDescription}
          onChange={(e) => setCompanyDescription(e.target.value)}
          placeholder="Describe what your company does and what types of regulatory information you want to monitor. For example: 'We are a fintech company providing lending services. We need to monitor financial regulations, consumer protection rules, and banking policy changes that could affect our business operations.'"
          required
          rows={4}
        />
        <div className="field-help">
          Please provide details about your business and the specific types of regulatory information you need to track.
        </div>
      </div>

      <div className="config-section">
        <label htmlFor="email">Email for Notifications: *</label>
        <input
          type="email"
          id="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="your.email@company.com"
          required
        />
      </div>

      <div className="config-section">
        <label htmlFor="agencies">Specific Agencies (Optional):</label>
        <input
          type="text"
          id="agencies"
          value={agencies}
          onChange={(e) => setAgencies(e.target.value)}
          placeholder="e.g., SEC, FDA, EPA, FTC (comma-separated)"
        />
        <div className="field-help">
          Leave blank to let AI determine relevant agencies based on your description, or specify particular agencies you're interested in.
        </div>
      </div>

      <div className="config-section">
        <label htmlFor="keywords">Keywords (Optional):</label>
        <input
          type="text"
          id="keywords"
          value={keywords}
          onChange={(e) => setKeywords(e.target.value)}
          placeholder="e.g., fintech, lending, consumer credit, data privacy (comma-separated)"
        />
        <div className="field-help">
          Add specific keywords to help filter relevant documents more precisely.
        </div>
      </div>

      {(companyDescription.trim() || email.trim() || agencies.trim() || keywords.trim()) && (
        <div className="selected-filters">
          <h3>Current Configuration:</h3>
          <div className="filter-summary">
            <div><strong>Company Description:</strong> {companyDescription || 'Required - please describe your company'}</div>
            <div><strong>Email:</strong> {email || 'Required - please enter your email'}</div>
            {agencies.trim() && <div><strong>Agencies:</strong> {agencies}</div>}
            {keywords.trim() && <div><strong>Keywords:</strong> {keywords}</div>}
          </div>
        </div>
      )}
    </div>
  );
};

export default MonitoringConfigComponent;